import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import Chatbot from './components/Chatbot';
import Navbar2 from './components/Navbar2';
import WhatsAppLink from './components/ContactLinks';
import PlacementAssistance from './components/PlacementAssistance';
import ActiveUsers1 from './components/ActiveUsers1';
import Card1 from './components/Card1';
import CourseGrid from './components/CoursesGrid';
import Feed1 from './components/Feed';
import Loader from './components/Loader';
import CourseGrid2 from './components/CoursesGrid2';
import Aboutus from './components/About/Aboutus';
import ContactForm from './components/ContactForm';
import FooterBottom from './components/FooterBottom';
import FooterMapSection from './components/FooterMap';
import ShortTermCourses from './components/ShortTermCourse/ShortTermCourses';
import JobOrientedCourses from './components/JobOrientedCourse/JobOrientedCourse';
import BatchScheduel from './components/BatchSchedule';
import CustomizedTraining from './components/CustomizedTraining';
import ScrollToTop from './components/ScrollToTop';
import TestimonialCarousel from './components/Testimonials';
import Header from './components/Header';
import StudentLogins from './components/StudentLogin'; // Ensure this is correctly imported


function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 100);
  }, []);

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="App">
      <Router>
        
        <Header />
        <Navbar2 />
        <Chatbot />
        <WhatsAppLink />
        <ScrollToTop />
        

        <Routes>
          <Route path="/query" element={<ContactForm />} />
          <Route path="/about-us" element={<Aboutus />} />
          <Route path="/short-term-courses" element={<ShortTermCourses />} />
          <Route path="/custing" element={<CustomizedTraining />} />
          <Route path="/batchscheduel" element={<BatchScheduel />} />
          <Route path="/job-oriented-courses" element={<JobOrientedCourses />} />
          <Route path="/student-login" element={<StudentLogins />} />
          <Route path="/" element={
            <>
              <PlacementAssistance />
              <Feed1 />
              <Card1 />
              <ActiveUsers1 />
              <CourseGrid /> 
              <CourseGrid2 />
              <FooterMapSection />
              <TestimonialCarousel />
            </>
          } />
        </Routes>

        <FooterBottom />
      </Router>
      
    </div>
  );
}

export default App;
